import { render, staticRenderFns } from "./Results.vue?vue&type=template&id=7a22621d&scoped=true&"
import script from "./Results.vue?vue&type=script&lang=js&"
export * from "./Results.vue?vue&type=script&lang=js&"
import style0 from "./Results.vue?vue&type=style&index=0&id=7a22621d&prod&scoped=true&lang=css&"
import style1 from "./Results.vue?vue&type=style&index=1&id=7a22621d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a22621d",
  null
  
)

export default component.exports